import { Ng2StateDeclaration, StatesModule } from '@uirouter/angular';
import { FiAreaListState } from '@fi-app/area/states/area-list-state';
import { FiAreaAddState } from '@fi-app/area/states/area-add-state';
import { FiAreaViewState } from '@fi-app/area/states/area-view-state';
import { FiAreaEditState } from '@fi-app/area/states/area-edit-state';
import { FiAreaDeleteState } from '@fi-app/area/states/area-delete-state';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';

export const FiAreaRootState: Ng2StateDeclaration = {
    name: FiStateNames.Area._name,
    url: '/Area',
    abstract: true,
    component: FiAbstractStateComponent,
};

export const FiAreaStates: StatesModule = {
    states: [FiAreaRootState, FiAreaListState, FiAreaAddState, FiAreaViewState, FiAreaEditState, FiAreaDeleteState],
};
